import { useEffect, useState, useMemo } from "react";
import "./LeaveBalanceDetails.css";
import { Form, Row, Col } from "react-bootstrap";
import ButtonCom from "../../../components/button/button";
import { ToastContainer, toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { AgGridReact } from "ag-grid-react";
import CustomPagination from "../../../components/CustomPagination";
// Icons -----------------------------------------
import { RiEdit2Line } from "react-icons/ri";
import { CgFileDocument } from "react-icons/cg";
import { FiPlus } from "react-icons/fi";
// Components -----------------------------------------
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import WidgetsButton from "../../../components/Widgets/button";
import CircularProgress from "../../../components/CircularProgress";

// Redux ----------------------------------------------
import { useDispatch } from "react-redux";
import { commonSaveData, initState } from "../../../redux/slices/commonSlice";
import {
  empLeavePolicyPath,
  empLeaveBalancePath,
} from "../../../services/config";
import { HasPermission } from "../../../services/hasPermission";

const LeaveBalanceDetails = ({ user, userDetails, commonState }) => {
  const items = [
    {
      name: "Leave Policy",
      tapItem: (
        <LeavePolicy
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
    },
    {
      name: "Leave Balance",
      tapItem: (
        <LeaveBalance
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
    },
    {
      name: "Leave Requests",
      tapItem: (
        <LeaveRequests
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
    },
  ];

  const userData = userDetails[0] || [];

  const [highlightTap, setHighlightTap] = useState(0);
  const [open, setOpen] = useState(false);

  const [leaveDetails, setLeaveDetails] = useState(
    userData?.leaveBalanceDetails?.leaveList || []
  );


  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const columns = useMemo(
    () => [
      {
        headerName: "Leave Type",
        width: "130px",
        cellRenderer: (rowData) => {
          return <span>{rowData.data.leaveName}</span>;
        },
      },
      {
        headerName: "Leave Title",
        width: "120px",
        cellRenderer: (rowData) => {
          return (
            <span>
              {rowData.data.leaveTitle ? rowData.data.leaveTitle : "-"}
            </span>
          );
        },
      },
      {
        headerName: "From Date",
        field: "startDate",
        width: "130px",
      },
      {
        headerName: "To Date",
        field: "endDate",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "130px",
      },
      {
        headerName: "Days",
        field: "duration",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "80px",
      },
      {
        headerName: "Note/Reason",
        cellRenderer: (rowData) => rowData.data.reason,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "300px",
        autoHeight: true,
        wrapText: true,
        resizable: true,
        cellClass: "custom-wrap-cell",
      },
      {
        headerName: "Status",
        cellRenderer: (rowData) =>
          rowData.data.approved == "0" ? "Rejected" : "Approved",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        width: "150px",
      },
    ],
    []
  );

  const preSubmit = () => {
    document.getElementById("submit-btn").click();
  };

  const submitForm = (e) => {
    e.preventDefault()
    setOpen(false)
  };

  const theme = localStorage.getItem("theme")
  

  return (
    <div style={{ padding: "0 10px" }}>
      <Row className="mb-3">
        <Col sm="6">
          <Widgets
            icon={
              <WidgetsIcon icon={<CgFileDocument />} title="Leave Policy" />
            }
            button={
              HasPermission("Leave & Balance Details", "edit") && (
                <WidgetsButton
                  type="button"
                  icon={<RiEdit2Line className="btn-icon" />}
                  onClick={null}
                />
              )
            }
            body={
              <>
                <div className="uni-flex-space-between">
                  <span className="color-gray">Leave Policy</span>
                  <span className="color-white">Annually</span>
                </div>

                <div className="uni-flex-space-between">
                  <span className="color-gray">Other Leave (PL)</span>
                  <span className="color-white">
                    {userData?.leaveBalanceDetails.leaveCount.otherLeaveCount}{" "}
                    Days
                  </span>
                </div>

                <div className="uni-flex-space-between">
                  <span className="color-gray">Casual Leave (CL)</span>
                  <span className="color-white">
                    {userData?.leaveBalanceDetails.leaveCount.casualLeaveCount}{" "}
                    Days
                  </span>
                </div>

                <div className="uni-flex-space-between">
                  <span className="color-gray">Sick Leave (SL)</span>
                  <span className="color-white">
                    {userData?.leaveBalanceDetails.leaveCount.sickLeaveCount}{" "}
                    Days
                  </span>
                </div>

                

                <div className="uni-flex-space-between">
                  <span className="color-gray">Loss Of Pay (LOP)</span>
                  <span className="color-white">NA</span>
                </div>
              </>
            }
          />
        </Col>

        <Col sm="6">
          <Widgets
            icon={
              <WidgetsIcon icon={<CgFileDocument />} title="Leave Balance" />
            }
            body={
              <Row className="mt-3">
                <Col sm="4" className="uni-flex-center mb-3">
                  <div className="flex-column align-items-center">
                    <h4 className="color-white">Casual Leave</h4>
                    <CircularProgress
                      v1={
                        userData?.leaveBalanceDetails.leaveCount
                          .takenCasualLeaveCount
                      }
                      v2={
                        userData?.leaveBalanceDetails.leaveCount
                          .casualLeaveCount
                      }
                      textSize="15"
                      textColor={theme == "light" ? "#000" : "#fff"}
                      pathColor="#FF6557"
                      trailColor="gray"
                      strokeWidth="18"
                    />
                  </div>
                </Col>
                <Col sm="4" className="uni-flex-center mb-3">
                  <div className="flex-column align-items-center">
                    <h4 className="color-white">Sick Leave</h4>
                    <CircularProgress
                      v1={
                        userData?.leaveBalanceDetails.leaveCount
                          .takenSickLeaveCount
                      }
                      v2={
                        userData?.leaveBalanceDetails.leaveCount.sickLeaveCount
                      }
                      textSize="15"
                      textColor={theme == "light" ? "#000" : "#fff"}
                      pathColor="#8660F8"
                      trailColor="gray"
                      strokeWidth="18"
                    />
                  </div>
                </Col>

                <Col sm="4" className="uni-flex-center mb-3">
                  <div className="flex-column align-items-center">
                    <h4 className="color-white">Other Leave</h4>
                    <CircularProgress
                      v1={
                        userData?.leaveBalanceDetails.leaveCount
                          .takenOtherLeaveCount
                      }
                      v2={
                        userData?.leaveBalanceDetails.leaveCount.otherLeaveCount
                      }
                      textSize="15"
                      textColor={theme == "light" ? "#000" : "#fff"}
                      pathColor="#FFCB3E"
                      trailColor="gray"
                      strokeWidth="18"
                    />
                  </div>
                </Col>
              </Row>
            }
          />
        </Col>

        <Col sm="12" className="mt-3">
          <Widgets
            icon={
              <WidgetsIcon icon={<CgFileDocument />} title="Leaves Details" />
            }
            button={
              HasPermission("Leave & Balance Details", "create") && (
                <WidgetsButton
                  type="button"
                  text="Add Leave"
                  icon={<FiPlus className="btn-icon" />}
                  onClick={() => setOpen(true)}
                />
              )
            }
            body={
              <>
                <div
                  className="ag-theme-quartz custom-grid"
                  style={{
                    position: "relative",
                    height: "480px",
                    width: "100%",
                    padding: "10px 20px",
                    zIndex: "0",
                  }}
                >
                  <AgGridReact
                    rowData={Array.isArray(leaveDetails) ? leaveDetails : []}
                    columnDefs={columns}
                    omLayout="autoHeight"
                    pagination={true}
                    paginationPageSize={paginationPageSize}
                    onGridReady={onGridReady}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between custom-pagination">
                  {gridApi && <CustomPagination gridApi={gridApi} />}
                </div>
              </>
            }
          />
        </Col>
      </Row>

      <Dialog fullWidth={true} open={open} onClose={() => setOpen(false)}>
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setOpen(false)}>
              X
            </span>
            <span className="title">Add Leave</span>
          </div>
          <button className="universal-btn" onClick={preSubmit}>
            Add Leave
          </button>
        </DialogTitle>

        <DialogContent
          style={{
            fontSize: "16px",
            fontWeight: "400",
          }}
        >
          <Form onSubmit={submitForm} className="mt-3">
            <Row>
              <Col sm="6" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">
                    Select Module
                  </Form.Label>
                  <Form.Select name="" value="" className="universal-input">
                    <option value="">Select Module</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col sm="6" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">
                    Leave Policy
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    value=""
                    placeholder="Enter Leave policy"
                    className="universal-input"
                  />
                </Form.Group>
              </Col>

              <Col sm="6" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">
                    Leave Type
                  </Form.Label>
                  <Form.Select name="" value="" className="universal-input">
                    <option value="">Select Leave Type</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col sm="6" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">
                    Add Leave Type
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    value=""
                    placeholder="Enter Leave type"
                    className="universal-input"
                  />
                </Form.Group>
              </Col>

              <Col sm="12" className="mb-3">
                <Form.Group>
                  <Form.Label className="color-gray mb-2">
                    No. of Leaves
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    value=""
                    placeholder="Enter Number of Leave"
                    className="universal-input"
                  />
                </Form.Group>
              </Col>

              <button
                type="submit"
                style={{ display: "none" }}
                id="submit-btn"
              ></button>
            </Row>
          </Form>
        </DialogContent>
      </Dialog>

      {/* <div className="LeaveBalanceDetails">
      <div className="LeaveBalanceDetails-body">
        <p>Leave Balance Details</p>
        <div className="LeaveBalanceDetails-card">
          <div className="LeaveBalanceDetails-card-items">
            <div className="LeaveBalanceDetails-tap">
              <div className="LeaveBalanceDetails-tap-item">
                {items.map((list, i) => (
                  <p
                    style={{
                      borderBottom: highlightTap === i ? "2px solid gray" : "",
                      fontSize: "16px",
                      cursor: "pointer",
                    }}
                    key={i}
                    onClick={() => setHighlightTap(i)}
                  >
                    {list.name}
                  </p>
                ))}
              </div>
            </div>

            <div className="LeaveBalanceDetails-tab-item">
              {items.map((item, i) => (
                <div key={i}>
                  {highlightTap === i ? <>{item.tapItem}</> : <></>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
 */}
    </div>
  );
};

const LeavePolicy = ({ user, userDetails, commonState }) => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("");
  const [confirm, setConfirm] = useState(false);
  const handleConfirm = () => setConfirm(true);
  const handleCloseConfirm = () => setConfirm(false);
  const [preLeaveType, setPreLeaveType] = useState("");

  const [leaves, setLeaves] = useState({
    allowed_leave0: "",
    carryforward_leave0: "",
    allowed_leave1: "",
    carryforward_leave1: "",
    allowed_leave2: "",
    carryforward_leave2: "",
  });

  const handleChangeInput = (e) => {
    const {
      target: { name, value },
    } = e;
    setLeaves({
      ...leaves,
      [name]: value,
    });
  };

  const handleOptionChange = (e) => {
    if (selectedOption == "") {
      setSelectedOption(e.target.value);
    } else {
      setPreLeaveType(e.target.value);
      handleConfirm();
    }
  };
  const handleMonthlyChange = () => {
    setSelectedOption("Monthly");
    handleCloseConfirm();
    setLeaves({
      ...leaves,
      allowed_leave0: "",
      carryforward_leave0: "",
      allowed_leave1: "",
      carryforward_leave1: "",
      allowed_leave2: "",
      carryforward_leave2: "",
    });
  };
  const handleYearlyChange = () => {
    setSelectedOption("Yearly");
    handleCloseConfirm();
    setLeaves({
      ...leaves,
      allowed_leave0: "",
      carryforward_leave0: "",
      allowed_leave1: "",
      carryforward_leave1: "",
      allowed_leave2: "",
      carryforward_leave2: "",
    });
  };
  const cancelChange = () => {
    if (preLeaveType == "Monthly") {
      setSelectedOption("Yearly");
    } else {
      setSelectedOption("Monthly");
    }
    handleCloseConfirm();
  };

  const handleSubmit = () => {
    let d = {
      path: empLeavePolicyPath,
      data: {
        userId: user.user_id,
        staffId: userDetails[0].staffId,
        leaveCycle: selectedOption == "Monthly" ? 1 : 2,
        leaves: [
          {
            leave_name: "Privilege leave",
            allowed_leave: leaves.allowed_leave0,
            carryforward_leave: leaves.carryforward_leave0,
          },
          {
            leave_name: "Casual leave",
            allowed_leave: leaves.allowed_leave2,
            carryforward_leave: leaves.carryforward_leave2,
          },
          {
            leave_name: "Sick leave",
            allowed_leave: leaves.allowed_leave1,
            carryforward_leave: leaves.carryforward_leave1,
          },
        ],
      },
    };
    dispatch(commonSaveData(d));
  };

  useEffect(() => {
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      dispatch(initState());
    }
  }, [commonState.commonSuccess]);

  return (
    <>
      <Dialog
        fullWidth={true}
        open={confirm}
        onClose={handleCloseConfirm}
        style={{ width: "30%", margin: "0 auto" }}
      >
        <DialogContent
          style={{
            fontSize: "16px",
            fontWeight: "400",
          }}
        >
          You will loss your previous data if you change attendance type.
        </DialogContent>
        <DialogActions style={{ borderTop: "1px solid lightgray" }}>
          <Button
            variant="contained"
            color="gray"
            onClick={cancelChange}
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              height: "38px",
              backgroundColor: "gray",
              color: "white",
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="info"
            onClick={
              preLeaveType == "Yearly"
                ? handleYearlyChange
                : handleMonthlyChange
            }
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              height: "38px",
              color: "white",
            }}
          >
            ok
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
      <div className="LeavePolicy">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <ButtonCom
            type="button"
            class_name={"p_btn"}
            text="Update Details"
            url_or_onclick={handleSubmit}
            icon=""
            width={""}
          />
        </div>

        <div className="LeavePolicy-card">
          <div
            className="LeavePolicy-radio-btn"
            style={{ alignItems: "center" }}
          >
            <p>Leave Policy</p>
            <label
              style={{
                fontSize: "16px",
              }}
            >
              <input
                id="radio-lP"
                type="radio"
                name="role"
                value="Monthly"
                checked={selectedOption === "Monthly"}
                onChange={handleOptionChange}
              />
              <samp>Monthly</samp>
            </label>
            <label
              style={{
                fontSize: "16px",
              }}
            >
              <input
                type="radio"
                name="role"
                value="Yearly"
                checked={selectedOption === "Yearly"}
                onChange={handleOptionChange}
              />
              <samp>Yearly</samp>
            </label>
          </div>
        </div>

        {selectedOption === "" && (
          <p className="" style={{ fontSize: "16px", marginTop: "50px" }}>
            Select Leave cycle to set Leave Policy{" "}
          </p>
        )}

        {selectedOption !== "" && (
          <Form>
            <div
              className="body-content"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div className="privileged-leave monthly-content-body">
                <h4>Privileged Leave</h4>

                <Form.Group className="form-group">
                  <Form.Label>Allowed Leaves</Form.Label>
                  <div className="input-label">
                    <Form.Control
                      name="allowed_leave0"
                      value={leaves.allowed_leave0}
                      data-leavename="Privileged Leave"
                      onChange={handleChangeInput}
                    />
                    <Form.Label>
                      leaves per{" "}
                      {selectedOption === "Monthly" ? "month" : "yearly"}
                    </Form.Label>
                  </div>
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Label>Carry Forward Leaves</Form.Label>
                  <div className="input-label">
                    <Form.Control
                      name="carryforward_leave0"
                      value={leaves.carryforward_leave0}
                      onChange={handleChangeInput}
                    />
                    <Form.Label>
                      leaves on{" "}
                      {selectedOption === "Monthly" ? "month" : "yearly"} end
                    </Form.Label>
                  </div>
                </Form.Group>
              </div>

              <div className="sick-leave monthly-content-body">
                <h4>Sick Leave</h4>
                <Form.Group className="form-group">
                  <Form.Label>Allowed Leaves</Form.Label>
                  <div className="input-label">
                    <Form.Control
                      name="allowed_leave1"
                      value={leaves.allowed_leave1}
                      onChange={handleChangeInput}
                    />
                    <Form.Label>
                      leaves per{" "}
                      {selectedOption === "Monthly" ? "month" : "yearly"}
                    </Form.Label>
                  </div>
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Label>Carry Forward Leaves</Form.Label>
                  <div className="input-label">
                    <Form.Control
                      name="carryforward_leave1"
                      value={leaves.carryforward_leave1}
                      onChange={handleChangeInput}
                    />
                    <Form.Label>
                      leaves on{" "}
                      {selectedOption === "Monthly" ? "month" : "yearly"} end
                    </Form.Label>
                  </div>
                </Form.Group>
              </div>

              <div className="casual-leave monthly-content-body">
                <h4>Casual leave</h4>
                <Form.Group className="form-group">
                  <Form.Label>Allowed Leaves</Form.Label>
                  <div className="input-label">
                    <Form.Control
                      name="allowed_leave2"
                      value={leaves.allowed_leave2}
                      onChange={handleChangeInput}
                    />
                    <Form.Label>
                      leaves per{" "}
                      {selectedOption === "Monthly" ? "month" : "yearly"}
                    </Form.Label>
                  </div>
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Label>Carry Forward Leaves</Form.Label>
                  <div className="input-label">
                    <Form.Control
                      name="carryforward_leave2"
                      value={leaves.carryforward_leave2}
                      onChange={handleChangeInput}
                    />
                    <Form.Label>
                      leaves on{" "}
                      {selectedOption === "Monthly" ? "month" : "yearly"} end
                    </Form.Label>
                  </div>
                </Form.Group>
              </div>
            </div>
          </Form>
        )}
      </div>
    </>
  );
};

const LeaveBalance = ({ user, userDetails, commonState }) => {
  const dispatch = useDispatch();
  const [leaves, setLeaves] = useState({
    leave_balance0: "",
    leave_balance1: "",
    leave_balance2: "",
  });

  const handleChangeInput = (e) => {
    const {
      target: { name, value },
    } = e;
    setLeaves({
      ...leaves,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    const lb = [];
    if (leaves.leave_balance0) {
      lb.push({
        leave_name: "Privilege leave",
        leave_balance: leaves.leave_balance0,
      });
    }
    if (leaves.leave_balance1) {
      lb.push({
        leave_name: "Sick leave",
        leave_balance: leaves.leave_balance1,
      });
    }
    if (leaves.leave_balance2) {
      lb.push({
        leave_name: "Casual leave",
        leave_balance: leaves.leave_balance2,
      });
    }
    const d = {
      path: empLeaveBalancePath,
      data: {
        userId: user.user_id,
        staffId: userDetails[0].staffId,
        leaves: lb,
      },
    };

    dispatch(commonSaveData(d));
  };

  useEffect(() => {
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      dispatch(initState());
    }

    if (commonState.commonError) {
      console.log(commonState);
      toast.success(commonState.commonMessage);
      dispatch(initState());
    }
  }, [commonState.commonSuccess, commonState.commonError]);

  return (
    <div className="LeaveBalance">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
        }}
      >
        <ButtonCom
          type="button"
          class_name={"p_btn"}
          text="Update Details"
          url_or_onclick={handleSubmit}
          icon=""
          width={""}
        />
      </div>

      <div className="LeaveBalance-card">
        <div className="body-content">
          <p>Remaining Balance</p>
        </div>
      </div>

      <Form style={{ marginTop: "-40px" }}>
        <div
          className="body-content"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="privileged-leave monthly-content-body">
            <Form.Group className="form-group">
              <Form.Label>Privileged Leave</Form.Label>
              <div className="input-label">
                <Form.Control
                  name="leave_balance0"
                  value={leaves.leave_balance0}
                  onChange={handleChangeInput}
                />
                <Form.Label>leaves</Form.Label>
              </div>
            </Form.Group>
          </div>
          <div className="sick-leave monthly-content-body">
            <Form.Group className="form-group">
              <Form.Label>Sick Leave</Form.Label>
              <div className="input-label">
                <Form.Control
                  name="leave_balance1"
                  value={leaves.leave_balance1}
                  onChange={handleChangeInput}
                />
                <Form.Label>leaves</Form.Label>
              </div>
            </Form.Group>
          </div>
          <div className="casual-leave monthly-content-body">
            <Form.Group className="form-group">
              <Form.Label>Casual leave</Form.Label>
              <div className="input-label">
                <Form.Control
                  name="leave_balance2"
                  value={leaves.leave_balance2}
                  onChange={handleChangeInput}
                />
                <Form.Label>leaves </Form.Label>
              </div>
            </Form.Group>
          </div>
        </div>
      </Form>
    </div>
  );
};

const LeaveRequests = () => {
  return (
    <div className="LeaveRequests">
      <div
        className="LeaveRequests-btn"
        style={{ gap: "10px", padding: "0 10px" }}
      >
        <ButtonCom
          type="button"
          class_name={"p_btn"}
          text="Pending"
          url_or_onclick={() => {}}
          icon={null}
          width={""}
        />
        <ButtonCom
          type="button"
          class_name={"p_btn"}
          text="History"
          url_or_onclick={() => {}}
          icon={null}
          width={""}
        />
      </div>

      <div className="LeaveRequests-input">
        <input
          placeholder="search staff bu name"
          id="LeaveRequests-input"
          style={{ borderRadius: "7px" }}
        />

        <select
          id="LeaveRequests-input"
          style={{ borderRadius: "7px", backgroundColor: "#ffffff" }}
        >
          <option value="Monthly">Branch</option>
        </select>

        <select
          id="LeaveRequests-input"
          style={{ borderRadius: "7px", backgroundColor: "#ffffff" }}
        >
          <option value="Monthly">Department</option>
        </select>

        <input
          id="LeaveRequests-input"
          type="date"
          style={{ borderRadius: "7px" }}
        />
      </div>
    </div>
  );
};

export default LeaveBalanceDetails;

// {
//     "leaveName": "Sick Leave",
//     "leaveTitle": "kvhn",
//     "startDate": "2025-06-01",
//     "endDate": "2025-06-01",
//     "refId": "1",
//     "leaveTypeId": "11",
//     "duration": "1",
//     "reason": "hjj lhkb",
//     "approved": "0",
//     "status": "1"
// }
